<template>
  <div>
    <h1>VMM</h1>
    <vue-json-pretty :data="access_token" />
    <button v-on:click="requestToken">GET TOKEN</button>
  </div>
</template>

<script>
import "vue-json-pretty/lib/styles.css";
import VueJsonPretty from "vue-json-pretty";
import { analytics } from "../config/firebaseInit";
export default {
  name: "vehiclematchmaker",
  components: {
    VueJsonPretty,
  },
  created() {
    analytics.logEvent("vehicle-match-maker");
  },
  data: function () {
    return {
      error: null,
      access_token: null,
      environment: "STG",
      loading: false,
    };
  },
  methods: {
    requestToken: async function () {
      this.loading = true;

      const config = {
        method: "post",
        url: "https://auth-stg.tcmobility.net/oauth2/token",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
            "Basic MzhsN2phaXVzZ3J0YmFjNzJrdHRpanNuOGU6MTltOGI5ZnJxNzhnMWc2ZnFkOTRoY3FwbnF0ZjdoZGExb3I5NnRtbmIzNnUwc3J1czdjcw==",
        },
        data: {
          grant_type: "client_credentials",
        },
      };

      this.axios(config)
        .then(function (response) {
          this.loading = false;
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(response.data));
          this.access_token = response.data.access_token;
        })
        .catch(function (error) {
          this.loading = false;
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
body {
  font-family: ToyotaType-Regular;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}

.tokenOutput {
  text-align: left !important;
}
</style>